import { EntityType } from "@ls/entity-service";
import { EntityRole } from "state/selections/Constants/EntityRole";

const PseudoBenchmark = {
  longName: "No Benchmark",
  path: ["PSEUDO_BMK"],
  entityId: Number.MAX_SAFE_INTEGER,
  type: EntityType.BMARK,
  isBenchmark: true,
  helperData: {
    entityRole: EntityRole.BENCHMARK,
  },
};

export default PseudoBenchmark;
